import { Badge } from '@/components/shadcn/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/shadcn/card'
import { RestSchemas } from '@/contexts/QueryProvider'
import { ENDPOINTS } from '@/util'
import { ApplicationIcon } from '@/const'
import { IconOpenInNewOutline } from '@icons/IconOpenInNewOutline'
import clsx from 'clsx'
import { statusBadge } from '../Applications/ApplicationsHome/ApllicationsGridItem'

type MessagesLandingApplicationMarketingCard = RestSchemas['Messages.Landing.ApplicationMarketingCard']

export function AppCard({
  app,
  layout = 'grid',
}: {
  app: MessagesLandingApplicationMarketingCard
  layout?: 'carousel' | 'grid'
}) {
  const {
    app_id,
    tag,
    card: { image, description, groupings, title, subtitle, url },
  } = app
  const isCarousel = layout === 'carousel'
  return (
    <div
      className={clsx(
        'grid h-full grid-cols-[100px_1fr] rounded-xl',
        isCarousel ? 'grid-cols-[150px_1fr] shadow-xl' : '!grid-cols-[100px_1fr] shadow'
      )}
    >
      <div
        className="justify-between rounded-l-xl border-r bg-muted bg-cover bg-center"
        style={{ backgroundImage: `url(${ENDPOINTS.DOTNET}/rest/support/getImage?imageKey=${image})` }}
      />
      <Card className="relative h-full gap-0 rounded-l-none border-none bg-background py-0 shadow-none">
        <IconOpenInNewOutline className="absolute right-3 top-3 size-7 text-primary opacity-0 group-hover:opacity-100" />
        <CardHeader className="bg-offwhite/50 border-b pb-4 pt-5">
          <CardTitle className="text-xl font-medium">
            <div className="flex w-full items-center justify-center gap-3">
              <div className="flex size-9 shrink-0 items-center justify-center rounded-full bg-muted">
                <ApplicationIcon className="h-4 w-4 text-muted-foreground" />
              </div>
              {title}
            </div>
          </CardTitle>
        </CardHeader>
        <CardContent
          className={clsx('relative flex flex-col items-center justify-center gap-y-3', isCarousel ? 'h-40' : 'h-40')}
        >
          <p className={clsx('text-base', isCarousel && 'px-20')}>{subtitle}</p>
          <Badge
            className={clsx(
              'absolute bottom-4 right-4 h-4 w-fit font-light',
              statusBadge[tag as keyof typeof statusBadge] || 'border-muted bg-muted text-foreground/50'
            )}
            variant="secondary"
          >
            {tag}
          </Badge>
        </CardContent>
      </Card>
    </div>
  )
}
